// Config panel for the "play_announcement" action block
// Plays an audio file to the caller before the next routing action
import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Alert,
} from '@mui/material';

const PlayAnnouncementConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    onSummaryChange(`Play: ${updated.audioFile || '?'}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Play a pre-recorded audio message to the caller before the next routing action executes.
      </Typography>

      <TextField
        size="small"
        label="Audio File"
        value={config.audioFile || ''}
        onChange={(e) => handleChange('audioFile', e.target.value)}
        required
        placeholder="demo-congrats"
        helperText="Asterisk sound file name without extension. Supports variables: {{variable}}"
      />

      <Typography variant="caption" color="text.secondary">
        Common built-in files: <code>demo-congrats</code>, <code>goodbye</code>,
        {' '}<code>vm-intro</code>, <code>silence/1</code>, <code>tt-monkeys</code>
      </Typography>

      <Alert severity="warning" variant="outlined" sx={{ py: 0.5, '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
        Place this block <strong>before</strong> a Route Call, Dial External, or Voicemail block.
        The audio plays to the caller before the routing action executes.
      </Alert>

      <Alert severity="info" variant="outlined" sx={{ py: 0.5, '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
        <strong>Language support:</strong> Audio is resolved per language automatically.
        Asterisk looks in <code>/var/lib/asterisk/sounds/&lt;language&gt;/</code> first
        (e.g. <code>nl/</code> for Dutch), then falls back to the default directory.
        Ensure the same filename exists for each supported language.
      </Alert>
    </Box>
  );
};

export default PlayAnnouncementConfig;
